import { render, staticRenderFns } from "./KwhPriceSetting.vue?vue&type=template&id=572cea23&scoped=true"
import script from "./KwhPriceSetting.vue?vue&type=script&lang=js"
export * from "./KwhPriceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572cea23",
  null
  
)

export default component.exports